namespace Ir.Components.Filters.DateRangeTypes {

    interface IDateRangeTypesViewModel{
        filter: Filter;
        dateRanges: KnockoutComputed<DateRange[]>;
        
        selectBoxSettings: DevExpress.ui.dxLookup.Properties;
        selectBoxComponent: DevExpress.ui.dxLookup;
        updatingDateRangeManually: boolean;

        dispose: Function;
    }

    export function getViewModel(this: IDateRangeTypesViewModel, params: IFilterParameterVM, componentInfo) {
        let self = this;
        this.filter = params.filter;
        
        this.dateRanges = ko.computed(function () {
            if (self.filter.filterEditorType() === FilterEditorTypeEnum.Date) {
                return DateRangeService.OnlySingleDates;
            }

            if (self.filter.filterEditorType() === FilterEditorTypeEnum.DateRange) {
                return DateRangeService.DatesRange;
            }
            return [];
        });

        this.updatingDateRangeManually = true;
        this.selectBoxSettings = {
            searchEnabled: true,
            searchExpr: ["initials", "name"],
            dataSource: this.dateRanges as any,
            displayExpr: 'initials',
            valueExpr: 'id',
            value: this.filter.dateRange(),
            width: 82,
            dropDownOptions: {
                width: 200,
                showTitle: false,
                hideOnOutsideClick: true,
                wrapperAttr: {
                    class: "date-range-types",
                },
            },
            showCancelButton: false,
            useNativeScrolling: false,
            itemTemplate(data) {
                return `<div class="initials">${data.initials()}</div><div class="dr-name"><small>${data.name()}</small></div>`;
            },
            onInitialized(e) {
                self.selectBoxComponent = e.component;

                setTimeout(function () {
                    if (self.filter.onContentReady) {
                        self.filter.onContentReady();
                    }
                }, 10)
            },
            onValueChanged: function (data) {
                if (data.previousValue !== data.value) {
                    if (self.updatingDateRangeManually) {
                        self.filter.dateRangeConfig.userDates(false);
                        self.filter.dateRangeConfig.lastDateUsed(null);
                        self.filter.dateRangeConfig.startDate(null);
                        self.filter.dateRangeConfig.endDate(null);
                    }

                    if (data.value === irGlobal.customDate.custom && data.previousValue !== irGlobal.customDate.custom && self.filter.scopeAction() === ScopeActionEnum.Combine &&
                        (self.filter.filterEditorType() === FilterEditorTypeEnum.DateRange || self.filter.filterEditorType() === FilterEditorTypeEnum.Date)) {
                        irGlobal.showToast("Changed the Scope Action to Default. Combine only works with a Date Range.", "warning");
                        self.filter.scopeAction(ScopeActionEnum.Default);
                    }

                    self.filter.dateRange(data.value);
                }

                self.updatingDateRangeManually = true;
            },
            onContentReady(e) {
                if (self.filter.onContentReady) {
                    self.filter.onContentReady();
                }
            }
        }

        this.filter.dateRange.subscribe(function (newValue) {
            self.updatingDateRangeManually = false;
            self.selectBoxComponent.option("value", newValue);
        });
    }
}